import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FieldType } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { ChildFieldToProfileField } from '../../../../helpers/to-profile-field/to-profile-field.helper';
import { ShComplexMapInputFieldComponent } from '../complex-map-input-field/complex-map-input-field.component';

@Component({
    selector: 'sh-timer-input-field',
    templateUrl: '../complex-map-input-field/complex-map-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShTimerInputFieldComponent extends ShComplexMapInputFieldComponent {
    initChildProfileFieldsStream(): void {
        // Convert child definitions to profile fields
        // Only show the DateFields
        // Set the EffectiveDate to readonly
        // Sort the DateFields
        this.childProfileFields$ = combineLatest([this.childDefinitions$, this.profileField$]).pipe(
            map(([children, profileField]) =>
                children.map(child => ChildFieldToProfileField(child, profileField, this.isBatchEdit))
            ),
            map(profileFields => this.filterTimerFields(profileFields)),
            map(profileFields => this.setEffectiveDateReadonly(profileFields)),
            map(profileFields => this.sortTimerFields(profileFields))
        );
    }

    private filterTimerFields(childProfileFields: ExtendedBaseProfileField[]): ExtendedBaseProfileField[] {
        return childProfileFields.filter(child => child.FieldDefinition.Type === FieldType.DateField);
    }

    private setEffectiveDateReadonly(childProfileFields: ExtendedBaseProfileField[]): ExtendedBaseProfileField[] {
        return childProfileFields.map((child: ExtendedBaseProfileField) =>
            child.FieldDefinition.Key === 'EffectiveDate'
                ? { ...child, FieldDefinition: { ...child.FieldDefinition, ReadOnly: true }, ReadOnly: true }
                : child
        );
    }

    // Sort the DateFields so that the EffectiveDate is always last
    private sortTimerFields(childProfileFields: ExtendedBaseProfileField[]): ExtendedBaseProfileField[] {
        return childProfileFields.sort((a, b) => {
            if (a.FieldDefinition.Key === 'EffectiveDate') {
                return 1;
            }
            if (b.FieldDefinition.Key === 'EffectiveDate') {
                return -1;
            }
            return 0;
        });
    }
}
